<div class="card-body">

    <div class="row">

        <div class="form-group col-md-4">
            <label>Duração (dias úteis) da Auditoria</label>
            <input disabled type="text" class="form-control form-control-sm"
                [ngModel]="cronograma?.qtdeDiasUteisAuditoria" [ngModelOptions]="{standalone: true}" />
        </div>

        <div class="form-group col-md-4">
            <label>Total de Dias Planejados</label>
            <input disabled type="text" class="form-control form-control-sm"
                [ngModel]="cronograma?.qtdeTotalDiasPlanejados" [ngModelOptions]="{standalone: true}" />
        </div>

        <div class="form-group col-md-4">
            <label>Dias Planejados Divergentes</label>
            <input disabled type="text" class="form-control form-control-sm"
                [ngModel]="getDiasPlanejadosDivergentes(cronograma?.qtdeDiasPlanejadosDivergentes)"
                [ngModelOptions]="{standalone: true}" />
        </div>

        <div class="form-group col-md-4">
        </div>

        <div class="form-group col-md-4">
            <label>Total de Dias Executados</label>
            <input disabled type="text" class="form-control form-control-sm"
                [ngModel]="cronograma?.qtdeTotalDiasExecutados" [ngModelOptions]="{standalone: true}" />
        </div>

        <div class="form-group col-md-4">
            <label>Dias Executados Divergentes</label>
            <input disabled type="text" class="form-control form-control-sm"
                [ngModel]="getDiasPlanejadosDivergentes(cronograma?.qtdeDiasExecutadosDivergentes)"
                [ngModelOptions]="{standalone: true}" />
        </div>
    </div>

    <div class="card-body p-0">
        <h3 class="m-4">Listagem de fases</h3>
        <table class="table table-hover ">
            <tbody *ngFor="let fase of cronograma?.fases; let i = index">
                <tr aria-expanded="false">
                    <td>
                        <div>
                            <p class="nome m-0"><a class="fa fas fa-plus" type="button" *ngIf="fase.atividades[0]"
                                    data-toggle="collapse" href="#collapseOne-{{i}}"></a><b>ﾠFase:ﾠ</b>ﾠ{{ fase.nome }}
                            </p>

                            <p class="btn btn-success bg-transparent btn-xs text-left left-dias">
                                <b>Dias Planejados:ﾠ</b> {{ fase.quantidadeDiasPlan }}
                            </p>

                            <p class="btn btn-success bg-transparent btn-xs text-left left-diasExec">
                                <b>Dias Executados:ﾠ</b> {{ fase.quantidadeDiasExec }}
                            </p>

                            <button 
                                *ngIf="!visualizar && fase.nome != 'Planejamento'" 
                                type="button" 
                                class="btn btn-success btn-xs text-left left"
                                (click)="modalIncluir(fase)">
                                <i class="fa fa-plus"></i>
                            </button>
                        </div>
                    </td>
                </tr>
                <tr class="expandable-body">
                    <td>
                        <div class="p-0" id="collapseOne-{{i}}">
                            <table class="table table-hover">
                                <tbody *ngFor="let atividade of fase.atividades; let i = index">
                                    <tr>
                                        <td>
                                            <div>
                                                <p class="nome m-0">
                                                    <b>ㅤAtividade: ﾠ</b>ﾠ{{
                                                    atividade.nome }}
                                                </p>
                                                <p class="btn btn-success bg-transparent btn-xs text-left left-dias">
                                                    <b>Dias Planejados:ﾠ</b>{{ atividade.quantidadeDiasPlan }}
                                                </p>

                                                <p class="btn btn-success bg-transparent btn-xs text-left left-diasExec">
                                                    <b>Dias Executados:ﾠ</b>{{ atividade.quantidadeDiasExec }}
                                                </p>

                                                <button *ngIf="!visualizar" type="button"
                                                    class="btn btn-primary btn-xs text-left left ml-2"
                                                    (click)="modalAlterar(atividade)">
                                                    <i class="fa fa-pen"></i>
                                                </button>

                                                <button 
                                                    *ngIf="!visualizar && atividade.atividadeId == null" 
                                                    type="button"
                                                    class="btn btn-danger btn-xs text-left left ml-4"
                                                    (click)="excluirAtividade(atividade.id)">
                                                    <i class="fa fa-trash-alt"></i>
                                                </button>

                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>